module.exports = __webpack_public_path__ + "static/media/community-like-post-orange.2f52ae36.svg";